    import React, { useEffect, useRef } from "react";
    import "./ClientConnectionModal.css";

    type Props = {
    isOpen: boolean;
    onClose: () => void;
    };

    const ClientConnectionModal: React.FC<Props> = ({ isOpen, onClose }) => {
    const overlayRef = useRef<HTMLDivElement | null>(null);

    useEffect(() => {
        const onKey = (e: KeyboardEvent) => {
        if (e.key === "Escape") onClose();
        };
        if (isOpen) document.addEventListener("keydown", onKey);
        return () => document.removeEventListener("keydown", onKey);
    }, [isOpen, onClose]);

    if (!isOpen) return null;

    const onOverlayClick = (e: React.MouseEvent) => {
        if (e.target === overlayRef.current) onClose();
    };

    return (
        <div className="modal-overlay" ref={overlayRef} onClick={onOverlayClick}>
        <div className="modal-window">
            <div className="popup-card">
                <button
                type="button"
                className="close-icon-btn cross-icon"
                onClick={onClose}
                aria-label="Close"
            >
                ×
            </button>
            <h2 className="popup-title">WHAT IS A CLIENT CONNECTION MEETING?</h2>

            <div className="popup-text top-text">
                <p>
                Benchmark Companies has built its product and service offerings
                as a relationships first model. The focus is to be the best
                version of ourselves, to constantly improve the services we
                offer to our friends.
                </p>

                <p>
                Mulch installation, specifically, is an &quot;all blame, no glory&quot;
                endeavor. If things go well, that&apos;s how it should be. If things
                go poorly, Benchmark owns it. We know what we signed up for and
                embrace the pursuit of making our clients properties look good.
                </p>

                <p>
                Over the past several years, we&apos;ve implemented several process
                and role modifications to improve our operation. Some have been
                successful, some have just created different problems to solve.
                The common theme is that none of these process improvements have
                required active participation from the client…until now.
                </p>

                <p>
                Communication in a dynamic, ever-changing, service-based
                industry is vital. Good news, bad news - you just need the
                news. In an effort to better align on the &quot;news&quot;, we have
                implemented utilizing a calendar scheduling app for optional
                weekly calls. Each Friday during &quot;season&quot;, clients will receive
                an email reminder with a calendar link, although it can be
                scheduled year round by utilizing the link within the portal.
                </p>

                <p>
                Will this be a little awkward and cumbersome at first?
                Absolutely. Will this result in a long-term alignment and
                communication improvement? Absolutely.
                </p>
            </div>

            <div className="popup-divider">SO, WHAT DO WE NEED FROM YOU?</div>

            <div className="popup-text bottom-text">
                <ul>
                <li>
                    Although these meetings are optional, please book meeting times
                    as quickly as possible so that our team can prepare for the
                    call. Each meeting will be slotted for 30 minutes, but our goal
                    is to wrap a call within 10 to 15 minutes so that we are
                    respectful of your time.
                </li>
                <li>
                    We are not perfect, but our goal is to provide a worry-free,
                    seamless mulch installation process. Positive collaboration on
                    the call will yield a much better result than negativity.
                </li>
                    <li>
                    While we can certainly deviate as the call dictates, we&apos;d like
                    to follow a similar structure to each call to streamline:
                </li>
                <ul>
                    <li>
                    Is there an upcoming property(ies) that require special
                    attention due to specific time constraints?
                    </li>
                    <li>
                    Hot button items: requested changes to schedule, target
                    dates for upcoming work
                    </li>
                    <li>Feedback on recently completed work</li>
                </ul>
                </ul>
            </div>

            <button className="close-btn" onClick={onClose}>
                Close
            </button>
            </div>
        </div>
        </div>
    );
    };

    export default ClientConnectionModal;
